import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { AcaoReuniao } from '../../../../../core/acao-reuniao';
import { Acesso } from '../../../../../core/acesso';
import { CarregarPerfil } from '../../../../../core/carregar-perfil';

@Component({
  selector: 'listar-acoes-reuniao',
  templateUrl: './listar-acoes-reuniao.component.html',
  styleUrls: ['./listar-acoes-reuniao.component.css']
})
export class ListarAcoesReuniaoComponent implements OnInit {

  @Output() onAtualizarAcao = new EventEmitter();
  @Output() onAbertoFormAdicaoAcaoReuniao = new EventEmitter();
  @Input() acoesReuniao: AcaoReuniao[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['nomeResponsavel', 'situacaoTipoAcao', 'descricaoAcao', 'dataPrazo', 'acoes'];
  dataSource: MatTableDataSource<AcaoReuniao> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();


  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.carregarLista();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["acoesReuniao"] && !_.isEmpty(changes["acoesReuniao"].currentValue)) {
      this.carregarLista();
    }
  }


  carregarLista() {
      if (_.isEmpty(this.acoesReuniao)) {
        this.mostrarTabela = false;
        this.msg = 'Nenhum ação cadastrada.';
      } else {
        this.dataSource.data = this.acoesReuniao;
        this.mostrarTabela = true;
    }
  }

  deletar(acaoReuniao: any): void {
    const index = this.acoesReuniao.indexOf( this.acoesReuniao.find(col => col === acaoReuniao));
    if (index >= 0) {
      this.acoesReuniao.splice(index, 1);
      this.carregarLista();
    }
  }

  atualizar(acaoReuniao: AcaoReuniao) {
    this.onAtualizarAcao.emit(acaoReuniao);
  }

  abrirFormAdicaoAcaoReuniao() {
    this.onAbertoFormAdicaoAcaoReuniao.emit(true);
  }

}
